module.exports = __webpack_public_path__ + "static/exchange_add_calendar_2-76cb7f758ff4fa0935652616d538c827.png";